import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { StudentsTable } from 'teacher-ui-client/components/assignments-admin/students-table/index'
import type AssignmentsProductManageMyStudentsRoute from 'teacher-ui-client/assignments/product/manage/my-students/route'
import type AssignmentsProductManageMyStudentsController from 'teacher-ui-client/assignments/product/manage/my-students/controller'

interface Signature {
  Args: {
    model: ModelFor<AssignmentsProductManageMyStudentsRoute>
    controller: AssignmentsProductManageMyStudentsController
  }
}
export const AssignmentsManageMyStudentsPage: TOC<Signature> = <template>
  <StudentsTable
    @subscriptionType={{@model.subscriptionType}}
    @students={{@model.students}}
    @assignments={{@model.assignments}}
    @selectedStudent={{@controller.selectedStudent}}
    @goToStudentAction={{@controller.goToStudent}}
    @schoolClasses={{@model.mySchoolClasses}}
    @selectedSchoolClassId={{@controller.selectedSchoolClassId}}
    @selectSchoolClassIdAction={{@controller.selectSchoolClassId}}
  />
</template>

export default RouteTemplate(AssignmentsManageMyStudentsPage)
